import {
  CREATE_MART_PRODUK_SUCCESS,
  RETRIEVE_MART_PRODUK_SUCCESS,
  UPDATE_MART_PRODUK_SUCCESS,
  DELETE_MART_PRODUK_SUCCESS,
} from "../actions/types";

const initialState = [];

function martProdukReducer(produks = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_MART_PRODUK_SUCCESS:
      return [...produks, payload];

    case RETRIEVE_MART_PRODUK_SUCCESS:
      return payload;

    case UPDATE_MART_PRODUK_SUCCESS:
      return produks.map((produk) => {
        if (produk.id === payload.id) {
          return {
            ...produk,
            ...payload,
          };
        } else {
          return produk;
        }
      });

    case DELETE_MART_PRODUK_SUCCESS:
      return produks.filter(({ id }) => id !== payload.id);

    default:
      return produks;
  }
}

export default martProdukReducer;
